import React, { useEffect, useRef } from 'react'
import { CButton } from '@coreui/react'

interface FirmaCanvasProps {
  value?: string | null
  onChange: (base64: string | null) => void
  height?: number
}

const FirmaCanvas: React.FC<FirmaCanvasProps> = ({ value, onChange, height = 140 }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const dibujando = useRef(false)
  const ultimoValor = useRef<string | null>(null)

  useEffect(() => {
    if (!value && ultimoValor.current !== null) {
      const canvas = canvasRef.current!
      canvas.getContext('2d')!.clearRect(0, 0, canvas.width, canvas.height)
      ultimoValor.current = null
    }
  }, [value])

  const punto = (e: React.MouseEvent | React.TouchEvent) => {
    const canvas = canvasRef.current!
    const rect = canvas.getBoundingClientRect()
    const t = 'touches' in e ? e.touches[0] : (e as React.MouseEvent)
    return { x: t.clientX - rect.left, y: t.clientY - rect.top }
  }

  const preparar = () => {
    const canvas = canvasRef.current!
    if (canvas.width !== canvas.clientWidth || canvas.height !== height) {
      canvas.width = canvas.clientWidth || 400
      canvas.height = height
    }
    const ctx = canvas.getContext('2d')!
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.lineWidth = 2
    ctx.strokeStyle = '#212529'
  }

  const comenzar = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault()
    preparar()
    dibujando.current = true
    const ctx = canvasRef.current!.getContext('2d')!
    const p = punto(e)
    ctx.beginPath()
    ctx.moveTo(p.x, p.y)
  }

  const mover = (e: React.MouseEvent | React.TouchEvent) => {
    if (!dibujando.current) return
    e.preventDefault()
    const ctx = canvasRef.current!.getContext('2d')!
    const p = punto(e)
    ctx.lineTo(p.x, p.y)
    ctx.stroke()
  }

  const terminar = () => {
    if (!dibujando.current) return
    dibujando.current = false
    const dataUrl = canvasRef.current!.toDataURL('image/png')
    ultimoValor.current = dataUrl.replace(/^data:image\/png;base64,/, '')
    onChange(ultimoValor.current)
  }

  const limpiar = () => {
    const canvas = canvasRef.current!
    canvas.getContext('2d')!.clearRect(0, 0, canvas.width, canvas.height)
    ultimoValor.current = null
    onChange(null)
  }

  return (
    <div>
      <div
        style={{
          border: '1px dashed #adb5bd',
          borderRadius: 8,
          background: '#fff',
          overflow: 'hidden',
        }}
      >
        <canvas
          ref={canvasRef}
          style={{ width: '100%', height, display: 'block', touchAction: 'none', cursor: 'crosshair' }}
          onMouseDown={comenzar}
          onMouseMove={mover}
          onMouseUp={terminar}
          onMouseLeave={terminar}
          onTouchStart={comenzar}
          onTouchMove={mover}
          onTouchEnd={terminar}
        />
      </div>
      <div className="mt-2 d-flex justify-content-end">
        <CButton size="sm" color="secondary" variant="outline" type="button" onClick={limpiar}>
          Limpiar
        </CButton>
      </div>
    </div>
  )
}

export default FirmaCanvas
